import { createContext, ReactNode, useContext } from "react";

import { useFilterTransportType } from "./filter-transport-type.hook";

const FilterTransportTypeContext = createContext(
  {} as ReturnType<typeof useFilterTransportType>
);
export function useFilterTransportTypeContext() {
  return useContext(FilterTransportTypeContext);
}

interface FilterTransportTypeProviderProps {
  children: ReactNode;
}
export function FilterTransportTypeProvider({
  children,
}: FilterTransportTypeProviderProps) {
  return (
    <FilterTransportTypeContext.Provider value={useFilterTransportType()}>
      {children}
    </FilterTransportTypeContext.Provider>
  );
}